// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Typography,
//   Select,
//   Button,
//   Card,
//   Divider,
//   Spin,
//   Pagination,
// } from "antd";
// import { FilterOutlined, DownOutlined, UserOutlined } from "@ant-design/icons";
// import { useLocation, useNavigate } from "react-router-dom";

// import LeadCard from "./LeadCard";
// import PriorityLeadCard from "./PriorityLeadCard";
// import StatisticsChart from "./StatisticsChart";
// import "./newDashboard.css";
// import useLeadOptions from "../../components/NewDashboard/UseLeadOptions";
// import useBusinessDashboardApi from "../../hooks/useBusinessDashboardApi";
// import NotificationPopup from "../../components/NotificationPopup";
// import axiosNew from "../../store/api/axiosNew";
// import { formatAmountIndian } from "./FormatAmount";
// import { useClientPagination } from "../../hooks/useClientPagination";
// import { NoLeads } from "../../utils/paginate";

// const { Title, Text } = Typography;

// export default function NewUserDashboardMobile({ navState }) {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const userName = localStorage.getItem("name");
//   const [selectedLead, setSelectedLead] = useState(null);
//   const [statusFilter, setStatusFilter] = useState("apartment");
//   const [leadNoti, setLeadNoti] = useState([]);
//   const [showPopup, setShowPopup] = useState(false);
//   const [loadingNav, setLoadingNav] = useState(false);
//   const [filteredLeadsNav, setFilteredLeadsNav] = useState([]);

//   const [lastSearchParams, setLastSearchParams] = useState({});
//   const [activeCategory, setActiveCategory] = useState("all");

//   const [subcategoryLeadsMap, setSubcategoryLeadsMap] = useState({});
//   const [subcategoryLoading, setSubcategoryLoading] = useState({});

//   const [locations, setLocations] = useState([]);
//   const [landTypes, setLandTypes] = useState([]);
//   const [budgets, setBudgets] = useState([]);
//   const [filters, setFilters] = useState({
//     location: [],
//     landType: [],
//     budget: [],
//     plotSize: [],
//   });

//   const preFetchedLeads = navState?.results || location.state?.results || [];
//   const getSelectedLeadIdFromURL = () => {
//     const params = new URLSearchParams(location.search);
//     return params.get("selectedleadid"); // returns the string ID or null
//   };
//   const {
//     allLeads,
//     pagination,
//     cartLeads,
//     fetchAllLeads,
//     loading,
//     updateLeadCategory,
//     addLeadToCart,
//     removeLeadFromCart,
//   } = useBusinessDashboardApi();

//   useEffect(() => {
//     const userId = localStorage.getItem("id");
//     const hasSeenPopup = sessionStorage.getItem("hasSeenPopup");

//     const notificationNewLead = async () => {
//       try {
//         const res = await axiosNew.get(`/notification/${userId}/unread`);
//         if (res.data.success && Array.isArray(res.data.data)) {
//           if (!hasSeenPopup) {
//             setLeadNoti(res.data.data);
//             setShowPopup(true);
//             sessionStorage.setItem("hasSeenPopup", "true");
//           }
//         } else {
//           setLeadNoti([]);
//           setShowPopup(false);
//         }
//       } catch (err) {
//         console.error("Error fetching unread leads:", err);
//       }
//     };
//     notificationNewLead();
//   }, []);

//   const transformLeadData = (lead) => ({
//     id: lead._id || lead.id,
//     name: lead.name,
//     place: lead.location,
//     price: lead.budget,
//     currentRate: lead.currentRate,
//     landType: lead.subcategory?.label || "",
//     rating: `${lead.timesBought || 0}/${lead.leadAvailableCount || 0}`,
//     status: lead.status || "",
//     siteVisit: lead.siteVisitDays?.join(", ") || "",
//     lookingFor: lead.property_details || "",
//     contact: lead.phone,
//     type: lead.leadType,
//     category: lead.category,
//     sqft: lead.spaceSqft || 0,
//     subCategoryId: lead.subcategory?._id,
//     subCategoryLabel: lead.subcategory?.label || "",
//     subCategoryName: lead.subcategory?.name || "",
//     state: lead.state || "",
//     district: lead.district || "",
//     area: lead.area || "",
//     pincode: lead.pincode || "",
//   });

//   const fetchCommonOptions = async (field, setter) => {
//     try {
//       const res = await axiosNew.get("admin/publicleads/common", {
//         params: { field },
//       });

//       const options = (res.data?.data || []).map((item) => {
//         const val = item.value; // don’t use .trim(), keep numbers as-is
//         const label =
//           typeof val === "number"
//             ? `${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(val)}`
//             : `${val?.trim()}`; // only trim strings
//         return {
//           value: val,
//           label: label,
//         };
//       });

//       setter(options);
//     } catch (err) {
//       console.error(`Failed to load ${field}`, err);
//     }
//   };

//   useEffect(() => {
//     fetchCommonOptions("location", setLocations);
//     fetchCommonOptions("landType", setLandTypes);
//     fetchCommonOptions("budget", setBudgets);
//   }, []);

//   const { hookLeads, finalLeads } = useMemo(() => {
//     const baseLeads = Array.isArray(allLeads)
//       ? allLeads.map(transformLeadData)
//       : [];
//     const navLeads = Array.isArray(filteredLeadsNav)
//       ? filteredLeadsNav.map(transformLeadData)
//       : [];

//     return {
//       hookLeads: baseLeads,
//       finalLeads: navLeads.length > 0 ? navLeads : baseLeads,
//     };
//   }, [allLeads, filteredLeadsNav]);

//   const selectedLeadIdFromURL = new URLSearchParams(location.search).get(
//     "selectedleadid",
//   );

//   useEffect(() => {
//     if (!selectedLeadIdFromURL) return;

//     fetchAllLeads(1, {
//       ...lastSearchParams,
//       leadId: selectedLeadIdFromURL,
//     });
//   }, [selectedLeadIdFromURL]);

//   useEffect(() => {
//     // If preFetchedLeads is the object from your JSON, we need the .data array
//     const leadsToSet = Array.isArray(preFetchedLeads)
//       ? preFetchedLeads
//       : preFetchedLeads?.data || [];

//     if (leadsToSet.length > 0) {
//       setFilteredLeadsNav(leadsToSet);
//     }
//   }, [preFetchedLeads]);

//   useEffect(() => {
//     if (!selectedLeadIdFromURL || !finalLeads.length) return;

//     const leadToSelect = finalLeads.find(
//       (lead) => lead.id === selectedLeadIdFromURL,
//     );

//     if (leadToSelect) {
//       setSelectedLead(leadToSelect);

//       // ⭐ VERY IMPORTANT
//       navigate(location.pathname, { replace: true });
//     }
//   }, [selectedLeadIdFromURL, finalLeads]);

//   const subCategoryOptions = [
//     { label: "Plot", value: "plot" },
//     { label: "Villa", value: "villa" },
//     { label: "Apartment", value: "apartment" },
//     { label: "Office", value: "office" },
//     { label: "Shop", value: "shop" },
//   ];

//   const handleSearch = () => {
//     const params = {};

//     if (filters.location?.length) {
//       params.location = filters.location.join(",");
//     }

//     if (filters.landType?.length) {
//       params.landType = filters.landType.join(",");
//     }

//     if (filters.budget?.length) {
//       params.budget = filters.budget.join(",");
//     }

//     if (activeCategory !== "all") {
//       setActiveCategory("all");
//     }

//     setLastSearchParams(params);
//     fetchAllLeads(1, params);
//   };

//   /* ---------------- PRIORITY LEAD ---------------- */
//   const priorityLead = hookLeads.find((lead) => {
//     const [purchased, total] = lead.rating.split("/").map(Number);
//     return total - purchased === 1;
//   });
//   const groupedBySubCategory = React.useMemo(() => {
//     if (!hookLeads.length) return {};
//     return hookLeads.reduce((acc, lead) => {
//       // const label = lead.subCategoryLabel;
//       const key = lead.subCategoryName; // "villa"
//       if (!key) return acc;
//       if (!acc[key]) {
//         acc[key] = {
//           label: lead.subCategoryLabel, // "Villa"
//           leads: [],
//         };
//       }

//       acc[key].leads.push(lead);

//       return acc;
//     }, {});
//   }, [hookLeads]);

//   const subCategoryCards = Object.values(groupedBySubCategory).map(
//     ({ label, leads }) => ({
//       subCategory: label,
//       count: leads.length,
//       leads,
//     }),
//   );

//   const bottomLeads = useMemo(() => {
//     if (!statusFilter) return [];

//     return subcategoryLeadsMap[statusFilter] || [];
//   }, [statusFilter, subcategoryLeadsMap]);

//   const handleLeadCheck = (lead, checked) => {
//     if (checked) addLeadToCart(lead);
//     else removeLeadFromCart(lead.id);
//   };

//   const handleClearSearchFilter = () => {
//     // 1. Reset local dashboard search dropdowns
//     setFilters({ location: [], landType: [], budget: [], plotSize: [] });
//     setLastSearchParams({});
//     fetchAllLeads(1, {});
//     // 2. Clear the pre-fetched results from the filter page
//     setFilteredLeadsNav([]);

//     // 3. Clear the router state so the data doesn't come back on refresh
//     navigate(location.pathname, { replace: true, state: {} });
//   };

//   const fetchLeadsBySubcategory = async (subcat) => {
//     setSubcategoryLoading((p) => ({ ...p, [subcat]: true }));

//     try {
//       const res = await axiosNew.get(`admin/publicleads/subcategory/${subcat}`);

//       const leads = Array.isArray(res.data?.data)
//         ? res.data.data.map(transformLeadData)
//         : [];

//       setSubcategoryLeadsMap((prev) => ({
//         ...prev,
//         [subcat]: leads,
//       }));
//     } catch (err) {
//       console.error(`Failed to fetch ${subcat} leads`, err);
//       setSubcategoryLeadsMap((prev) => ({
//         ...prev,
//         [subcat]: [],
//       }));
//     } finally {
//       setSubcategoryLoading((p) => ({ ...p, [subcat]: false }));
//     }
//   };
//   useEffect(() => {
//     subCategoryOptions.forEach((sc) => {
//       fetchLeadsBySubcategory(sc.value);
//     });
//   }, []);

//   const CATEGORY_PAGE_SIZE = 10;

//   const isAllTab = activeCategory === "all";

//   const categoryPagination = useClientPagination({
//     data: isAllTab ? [] : subcategoryLeadsMap[activeCategory] || [],
//     pageSize: CATEGORY_PAGE_SIZE,
//     resetKey: activeCategory,
//   });

//   const displayedLeads = isAllTab ? finalLeads : categoryPagination.items;

//   return (
//     <div style={{ padding: 0, paddingBottom: 90 }}>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "flex-end",
//           marginBottom: 8,
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",

//             gap: 8,
//             padding: "6px 12px",
//             background: "#fff",
//             borderRadius: 8,
//             boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
//             border: "1px solid #f0f0f0",
//             lineHeight: 1,
//           }}
//         >
//           <UserOutlined style={{ color: "#1890ff" }} />
//           <Title strong style={{ fontSize: 15, marginTop: "2px" }}>
//             {userName}
//           </Title>
//         </div>
//       </div>
//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <Title level={4}>Search Lead</Title>
//         <FilterOutlined
//           style={{ fontSize: 20 }}
//           onClick={() => navigate("/user-dashboard-filter")}
//         />
//       </div>

//       <Card bordered style={{ borderColor: "#98c3ffff", marginBottom: 12 }}>
//         <div style={{ display: "grid", gridTemplateColumns: "1fr 1px 1fr" }}>
//           <Select
//             mode="multiple"
//             placeholder="Location"
//             bordered={false}
//             value={filters.location}
//             onChange={(v) => setFilters({ ...filters, location: v })}
//             options={locations}
//           />
//           <div style={{ width: 1, background: "#d9d9d9" }} />
//           <Select
//             mode="multiple"
//             placeholder="Land Type"
//             bordered={false}
//             value={filters.landType}
//             onChange={(v) => setFilters({ ...filters, landType: v })}
//             options={landTypes}
//           />
//         </div>

//         <Divider style={{ margin: "8px 0" }} />

//         <div style={{ display: "grid", gridTemplateColumns: "1fr 1px 1fr" }}>
//           <Select
//             mode="multiple"
//             placeholder="Budget Range"
//             bordered={false}
//             value={filters.budget}
//             onChange={(v) => setFilters({ ...filters, budget: v })}
//             options={budgets}
//           />
//           {/* <div style={{ width: 1, background: "#d9d9d9" }} /> */}
//           {/* <Select
//             mode="multiple"
//             placeholder="Plot Size"
//             bordered={false}
//             value={filters.plotSize}
//             onChange={(v) => setFilters({ ...filters, plotSize: v })}
//             options={plotSizeOptions}
//           /> */}
//         </div>
//       </Card>

//       <div style={{ display: "flex", justifyContent: "space-between" }}>
//         <Button
//           type="primary"
//           block
//           style={{ marginBottom: 20, width: "50%" }}
//           onClick={handleSearch}
//         >
//           Search
//         </Button>
//         <Button
//           danger
//           onClick={handleClearSearchFilter}
//           style={{ marginRight: 8 }}
//         >
//           Clear
//         </Button>
//       </div>

//       {/* ================= PRIORITY LEAD ================= */}
//       {/* {priorityLead && ( */}
//       <PriorityLeadCard
//         // name={priorityLead.name}
//         // place={priorityLead.place}
//         // rating={priorityLead.rating}
//         onTopPickClick={(leadId) =>
//           navigate(`/user-dashboard?selectedleadid=${leadId}`)
//         }
//       />
//       {/* )} */}

//       {/* ================= ALL LEADS ================= */}
//       <Title level={4} style={{ marginTop: 16 }}>
//         Leads
//       </Title>

//       {leadNoti.length > 0 && (
//         <NotificationPopup
//           show={showPopup}
//           handleClose={() => setShowPopup(false)}
//           lead={leadNoti[0]}
//         />
//       )}
//       <div
//         style={{
//           display: "flex",
//           gap: 6,
//           overflowX: "auto",
//           paddingBottom: 6,
//         }}
//       >
//         {[{ label: "All", value: "all" }, ...subCategoryOptions].map((cat) => (
//           <Button
//             key={cat.value}
//             type={activeCategory === cat.value ? "primary" : "default"}
//             onClick={() => setActiveCategory(cat.value)}
//             style={{
//               flexShrink: 0,
//               borderRadius: 20,
//               padding: "10px 18px", // slightly taller tabs
//               minHeight: 40, // improves tap area
//               marginBottom: 4,
//             }}
//           >
//             {cat.label}
//           </Button>
//         ))}
//       </div>

//       {activeCategory === "all" && Object.keys(lastSearchParams).length > 0 && (
//         <Text
//           type="secondary"
//           style={{
//             fontSize: 12,
//             marginBottom: 8,
//             display: "block",
//           }}
//         >
//           {filters.location.length ||
//           filters.landType.length ||
//           filters.budget.length
//             ? "Search results from all leads"
//             : "Filtered results from all leads"}
//         </Text>
//       )}

//       <div
//         style={{
//           background: "#fff",
//           borderRadius: 12,
//           padding: "8px",
//           marginBottom: "4px",
//           marginTop: "12px",
//         }}
//       >
//         {loading ? (
//           <div style={{ textAlign: "center", padding: 20 }}>
//             <Spin />
//           </div>
//         ) : displayedLeads.length === 0 ? (
//           <NoLeads
//             text={
//               activeCategory === "all"
//                 ? "No leads available"
//                 : `No ${activeCategory} leads available`
//             }
//           />
//         ) : (
//           displayedLeads.map((lead) => (
//             <div key={lead.id} style={{ marginBottom: 8 }}>
//               <LeadCard
//                 {...lead}
//                 showCheckbox
//                 checked={cartLeads.some((l) => l.id === lead.id)}
//                 onCheck={(id, checked) => handleLeadCheck(lead, checked)}
//                 onClick={() =>
//                   setSelectedLead(selectedLead?.id === lead.id ? null : lead)
//                 }
//               />

//               {/* ===== INLINE DETAILS ===== */}
//               {selectedLead?.id === lead.id && (
//                 <Card style={{ background: "#fafafa", marginTop: 8 }}>
//                   <div
//                     style={{ display: "flex", justifyContent: "flex-end" }}
//                   ></div>
//                   <Text strong>Lead Details</Text>
//                   <Divider style={{ margin: "8px 0" }} />

//                   <div
//                     style={{
//                       display: "grid",
//                       gridTemplateColumns: "1fr 1px 1fr",
//                       alignItems: "center",
//                     }}
//                   >
//                     <div style={{ padding: 6 }}>
//                       <strong>Name</strong>
//                       <div>{lead.name}</div>
//                     </div>

//                     <div
//                       style={{
//                         width: 1,
//                         height: "100%",
//                         background: "#DBEAFF",
//                       }}
//                     />

//                     <div style={{ padding: 6 }}>
//                       <strong>Contact No.</strong>
//                       <div>{lead.contact}</div>
//                     </div>
//                   </div>

//                   <Divider style={{ margin: "6px 0" }} />

//                   {/* GRID ROW 2 */}
//                   <div
//                     style={{
//                       display: "grid",
//                       gridTemplateColumns: "1fr 1px 1fr",
//                       alignItems: "center",
//                     }}
//                   >
//                     <div style={{ padding: 6 }}>
//                       <strong>Client Location</strong>
//                       <div>{lead.place}</div>
//                     </div>

//                     <div
//                       style={{
//                         width: 1,
//                         height: "100%",
//                         background: "#DBEAFF",
//                       }}
//                     />

//                     <div style={{ padding: 6 }}>
//                       <strong>Sq.ft</strong>
//                       <div>{lead.sqft}</div>
//                     </div>
//                   </div>

//                   <Divider style={{ margin: "6px 0" }} />

//                   {/* GRID ROW 3 */}
//                   <div
//                     style={{
//                       display: "grid",
//                       gridTemplateColumns: "1fr 1px 1fr",
//                       alignItems: "center",
//                     }}
//                   >
//                     <div style={{ padding: 6 }}>
//                       <strong>Budget</strong>
//                       <div>₹ {formatAmountIndian(lead.price)}</div>
//                     </div>

//                     <div
//                       style={{
//                         width: 1,
//                         height: "100%",
//                         background: "#DBEAFF",
//                       }}
//                     />

//                     <div style={{ padding: 6 }}>
//                       <strong>Preferred location</strong>
//                       <p>
//                         {lead?.state || ""}-{lead?.district || ""}-
//                         {lead?.area || ""}--
//                         {lead?.pincode || ""}
//                       </p>
//                     </div>
//                   </div>

//                   <Divider style={{ margin: "6px 0" }} />

//                   {/* GRID ROW 4 */}
//                   <div
//                     style={{
//                       display: "grid",
//                       gridTemplateColumns: "1fr 1px 1fr",
//                       alignItems: "center",
//                     }}
//                   >
//                     <div style={{ padding: 6 }}>
//                       <strong>Site Visit</strong>
//                       <div>{lead.siteVisit}</div>
//                     </div>

//                     <div
//                       style={{
//                         width: 1,
//                         height: "100%",
//                         background: "#DBEAFF",
//                       }}
//                     />

//                     <div style={{ padding: 6 }}>
//                       <strong>Looking For</strong>
//                       <div>{lead.lookingFor}</div>
//                     </div>
//                   </div>

//                   <Button
//                     type="primary"
//                     block
//                     style={{ marginTop: 12 }}
//                     onClick={() => handleLeadCheck(lead, true)}
//                   >
//                     Add to cart
//                   </Button>
//                 </Card>
//               )}
//             </div>
//           ))
//         )}
//       </div>
//       {isAllTab ? (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             marginTop: 16,
//           }}
//         >
//           <Pagination
//             simple
//             showSizeChanger={false}
//             current={pagination.page}
//             total={pagination.total || 10}
//             pageSize={pagination.limit}
//             onChange={(page) => fetchAllLeads(page, lastSearchParams)}
//             style={{ marginTop: 8, textAlign: "center" }}
//           />
//         </div>
//       ) : (
//         <div
//           style={{
//             display: "flex",
//             justifyContent: "center",
//             marginTop: 16,
//           }}
//         >
//           <Pagination
//             simple
//             current={categoryPagination.page}
//             total={categoryPagination.total || 10}
//             pageSize={CATEGORY_PAGE_SIZE}
//             showSizeChanger={false}
//             onChange={categoryPagination.setPage}
//           />
//         </div>
//       )}

//       {/* ================= CHART ================= */}
//       <Title level={5} style={{ marginTop: 16 }}>
//         Lead Statistics
//       </Title>

//       <Card>
//         <StatisticsChart />
//       </Card>

//       {/* ================= CART BAR ================= */}
//       {cartLeads.length > 0 && (
//         <div
//           style={{
//             position: "fixed",
//             bottom: 0,
//             left: 0,
//             width: "100%",
//             background: "#fff",
//             borderTop: "1px solid #ddd",
//             padding: 12,
//             display: "flex",
//             justifyContent: "space-between",
//             zIndex: 1000,
//           }}
//         >
//           <div>
//             <strong>{cartLeads.length}</strong>{" "}
//             {cartLeads.length === 1 ? "lead" : "leads"} selected
//             <div style={{ fontSize: 12, color: "#666" }}>
//               * Amount may change in real time
//             </div>
//           </div>
//           <Button type="primary" onClick={() => navigate("/my-cart")}>
//             Buy Now
//           </Button>
//         </div>
//       )}
//     </div>
//   );
// }


import React, { useEffect, useMemo, useState } from "react";
import {
  Typography,
  Select,
  Button,
  Card,
  Divider,
  Spin,
  Pagination,
} from "antd";
import {
  FilterOutlined,
  UserOutlined,
  ShoppingCartOutlined,
  CheckOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

import LeadCard from "./LeadCard";
import PriorityLeadCard from "./PriorityLeadCard";
import StatisticsChart from "./StatisticsChart";
import "./newDashboard.css";
import useBusinessDashboardApi from "../../hooks/useBusinessDashboardApi";
import NotificationPopup from "../../components/NotificationPopup";
import axiosNew from "../../store/api/axiosNew";
import { formatAmountIndian } from "./FormatAmount";
import { useClientPagination } from "../../hooks/useClientPagination";
import { NoLeads } from "../../utils/paginate";

const { Title, Text } = Typography;

export default function NewUserDashboardMobile({ navState }) {
  const navigate = useNavigate();
  const location = useLocation();
  const userName = localStorage.getItem("name");

  const [selectedLead, setSelectedLead] = useState(null);
  const [isHoveredDetail, setIsHoveredDetail] = useState(false);
  const [statusFilter, setStatusFilter] = useState("apartment");
  const [leadNoti, setLeadNoti] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [filteredLeadsNav, setFilteredLeadsNav] = useState([]);

  const [lastSearchParams, setLastSearchParams] = useState({});
  const [activeCategory, setActiveCategory] = useState("all");

  const [subcategoryLeadsMap, setSubcategoryLeadsMap] = useState({});
  const [subcategoryLoading, setSubcategoryLoading] = useState({});

  const [locations, setLocations] = useState([]);
  const [landTypes, setLandTypes] = useState([]);
  const [budgets, setBudgets] = useState([]);
  const [filters, setFilters] = useState({
    location: [],
    landType: [],
    budget: [],
    plotSize: [],
  });

  const preFetchedLeads = navState?.results || location.state?.results || [];

  const {
    allLeads,
    pagination,
    cartLeads,
    fetchAllLeads,
    loading,
    addLeadToCart,
    removeLeadFromCart,
  } = useBusinessDashboardApi();

  useEffect(() => {
    const userId = localStorage.getItem("id");
    const hasSeenPopup = sessionStorage.getItem("hasSeenPopup");

    const notificationNewLead = async () => {
      try {
        const res = await axiosNew.get(`/notification/${userId}/unread`);
        if (res.data.success && Array.isArray(res.data.data)) {
          if (!hasSeenPopup) {
            setLeadNoti(res.data.data);
            setShowPopup(true);
            sessionStorage.setItem("hasSeenPopup", "true");
          }
        } else {
          setLeadNoti([]);
          setShowPopup(false);
        }
      } catch (err) {
        console.error("Error fetching unread leads:", err);
      }
    };
    notificationNewLead();
  }, []);

  const transformLeadData = (lead) => ({
    id: lead._id || lead.id,
    name: lead.name,
    place: lead.location,
    price: lead.budget,
    currentRate: lead.currentRate,
    landType: lead.subcategory?.label || "",
    rating: `${lead.timesBought || 0}/${lead.leadAvailableCount || 0}`,
    status: lead.status || "",
    siteVisit: lead.siteVisitDays?.join(", ") || "",
    lookingFor: lead.property_details || "",
    contact: lead.phone,
    type: lead.leadType,
    category: lead.category,
    sqft: lead.spaceSqft || 0,
    subCategoryId: lead.subcategory?._id,
    subCategoryLabel: lead.subcategory?.label || "",
    subCategoryName: lead.subcategory?.name || "",
    state: lead.state || "",
    district: lead.district || "",
    area: lead.area || "",
    pincode: lead.pincode || "",
  });

  const fetchCommonOptions = async (field, setter) => {
    try {
      const res = await axiosNew.get("admin/publicleads/common", {
        params: { field },
      });

      const options = (res.data?.data || []).map((item) => {
        const val = item.value;
        const label =
          typeof val === "number"
            ? `${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(val)}`
            : `${val?.trim()}`;
        return {
          value: val,
          label: label,
        };
      });

      setter(options);
    } catch (err) {
      console.error(`Failed to load ${field}`, err);
    }
  };

  useEffect(() => {
    fetchCommonOptions("location", setLocations);
    fetchCommonOptions("landType", setLandTypes);
    fetchCommonOptions("budget", setBudgets);
  }, []);

  const { hookLeads, finalLeads } = useMemo(() => {
    const baseLeads = Array.isArray(allLeads)
      ? allLeads.map(transformLeadData)
      : [];
    const navLeads = Array.isArray(filteredLeadsNav)
      ? filteredLeadsNav.map(transformLeadData)
      : [];

    return {
      hookLeads: baseLeads,
      finalLeads: navLeads.length > 0 ? navLeads : baseLeads,
    };
  }, [allLeads, filteredLeadsNav]);

  const selectedLeadIdFromURL = new URLSearchParams(location.search).get(
    "selectedleadid",
  );

  useEffect(() => {
    if (!selectedLeadIdFromURL) return;

    fetchAllLeads(1, {
      ...lastSearchParams,
      leadId: selectedLeadIdFromURL,
    });
  }, [selectedLeadIdFromURL]);

  useEffect(() => {
    const leadsToSet = Array.isArray(preFetchedLeads)
      ? preFetchedLeads
      : preFetchedLeads?.data || [];

    if (leadsToSet.length > 0) {
      setFilteredLeadsNav(leadsToSet);
    }
  }, [preFetchedLeads]);

  useEffect(() => {
    if (!selectedLeadIdFromURL || !finalLeads.length) return;

    const leadToSelect = finalLeads.find(
      (lead) => lead.id === selectedLeadIdFromURL,
    );

    if (leadToSelect) {
      setSelectedLead(leadToSelect);
      navigate(location.pathname, { replace: true });
    }
  }, [selectedLeadIdFromURL, finalLeads]);

  const subCategoryOptions = [
    { label: "Plot", value: "plot" },
    { label: "Villa", value: "villa" },
    { label: "Apartment", value: "apartment" },
    { label: "Office", value: "office" },
    { label: "Shop", value: "shop" },
  ];

  const handleSearch = () => {
    const params = {};

    if (filters.location?.length) {
      params.location = filters.location.join(",");
    }

    if (filters.landType?.length) {
      params.landType = filters.landType.join(",");
    }

    if (filters.budget?.length) {
      params.budget = filters.budget.join(",");
    }

    if (activeCategory !== "all") {
      setActiveCategory("all");
    }

    setLastSearchParams(params);
    fetchAllLeads(1, params);
  };

  const handleLeadCheck = (lead, checked) => {
    if (checked) addLeadToCart(lead);
    else removeLeadFromCart(lead.id);
  };

  const handleClearSearchFilter = () => {
    setFilters({ location: [], landType: [], budget: [], plotSize: [] });
    setLastSearchParams({});
    fetchAllLeads(1, {});
    setFilteredLeadsNav([]);
    navigate(location.pathname, { replace: true, state: {} });
  };

  const fetchLeadsBySubcategory = async (subcat) => {
    setSubcategoryLoading((p) => ({ ...p, [subcat]: true }));

    try {
      const res = await axiosNew.get(`admin/publicleads/subcategory/${subcat}`);

      const leads = Array.isArray(res.data?.data)
        ? res.data.data.map(transformLeadData)
        : [];

      setSubcategoryLeadsMap((prev) => ({
        ...prev,
        [subcat]: leads,
      }));
    } catch (err) {
      console.error(`Failed to fetch ${subcat} leads`, err);
      setSubcategoryLeadsMap((prev) => ({
        ...prev,
        [subcat]: [],
      }));
    } finally {
      setSubcategoryLoading((p) => ({ ...p, [subcat]: false }));
    }
  };

  useEffect(() => {
    subCategoryOptions.forEach((sc) => {
      fetchLeadsBySubcategory(sc.value);
    });
  }, []);

  const CATEGORY_PAGE_SIZE = 10;
  const isAllTab = activeCategory === "all";

  const categoryPagination = useClientPagination({
    data: isAllTab ? [] : subcategoryLeadsMap[activeCategory] || [],
    pageSize: CATEGORY_PAGE_SIZE,
    resetKey: activeCategory,
  });

  const displayedLeads = isAllTab ? finalLeads : categoryPagination.items;

  return (
    <div style={{ padding: 0, paddingBottom: 90 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 8,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "6px 12px",
            background: "#fff",
            borderRadius: 8,
            boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
            border: "1px solid #f0f0f0",
            lineHeight: 1,
          }}
        >
          <UserOutlined style={{ color: "#1890ff" }} />
          <Title strong style={{ fontSize: 15, marginTop: "2px" }}>
            {userName}
          </Title>
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Title level={4}>Search Lead</Title>
        <FilterOutlined
          style={{ fontSize: 20 }}
          onClick={() => navigate("/user-dashboard-filter")}
        />
      </div>

      <Card bordered style={{ borderColor: "#98c3ffff", marginBottom: 12 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1px 1fr" }}>
          <Select
            mode="multiple"
            placeholder="Location"
            bordered={false}
            value={filters.location}
            onChange={(v) => setFilters({ ...filters, location: v })}
            options={locations}
          />
          <div style={{ width: 1, background: "#d9d9d9" }} />
          <Select
            mode="multiple"
            placeholder="Land Type"
            bordered={false}
            value={filters.landType}
            onChange={(v) => setFilters({ ...filters, landType: v })}
            options={landTypes}
          />
        </div>

        <Divider style={{ margin: "8px 0" }} />

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1px 1fr" }}>
          <Select
            mode="multiple"
            placeholder="Budget Range"
            bordered={false}
            value={filters.budget}
            onChange={(v) => setFilters({ ...filters, budget: v })}
            options={budgets}
          />
        </div>
      </Card>

      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button
          type="primary"
          block
          style={{ marginBottom: 20, width: "50%" }}
          onClick={handleSearch}
        >
          Search
        </Button>
        <Button
          danger
          onClick={handleClearSearchFilter}
          style={{ marginRight: 8 }}
        >
          Clear
        </Button>
      </div>

      {/* PRIORITY LEAD */}
      <PriorityLeadCard
        onTopPickClick={(leadId) =>
          navigate(`/user-dashboard?selectedleadid=${leadId}`)
        }
      />

      {/* ALL LEADS */}
      <Title level={4} style={{ marginTop: 16 }}>
        Leads
      </Title>

      {leadNoti.length > 0 && (
        <NotificationPopup
          show={showPopup}
          handleClose={() => setShowPopup(false)}
          lead={leadNoti[0]}
        />
      )}

      <div
        style={{
          display: "flex",
          gap: 6,
          overflowX: "auto",
          paddingBottom: 6,
        }}
      >
        {[{ label: "All", value: "all" }, ...subCategoryOptions].map((cat) => (
          <Button
            key={cat.value}
            type={activeCategory === cat.value ? "primary" : "default"}
            onClick={() => setActiveCategory(cat.value)}
            style={{
              flexShrink: 0,
              borderRadius: 20,
              padding: "10px 18px",
              minHeight: 40,
              marginBottom: 4,
            }}
          >
            {cat.label}
          </Button>
        ))}
      </div>

      {activeCategory === "all" && Object.keys(lastSearchParams).length > 0 && (
        <Text
          type="secondary"
          style={{
            fontSize: 12,
            marginBottom: 8,
            display: "block",
          }}
        >
          {filters.location.length ||
          filters.landType.length ||
          filters.budget.length
            ? "Search results from all leads"
            : "Filtered results from all leads"}
        </Text>
      )}

      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: "8px",
          marginBottom: "4px",
          marginTop: "12px",
        }}
      >
        {loading ? (
          <div style={{ textAlign: "center", padding: 20 }}>
            <Spin />
          </div>
        ) : displayedLeads.length === 0 ? (
          <NoLeads
            text={
              activeCategory === "all"
                ? "No leads available"
                : `No ${activeCategory} leads available`
            }
          />
        ) : (
          displayedLeads.map((lead) => (
            <div key={lead.id} style={{ marginBottom: 8 }}>
              <LeadCard
                {...lead}
                showCheckbox
                checked={cartLeads.some((l) => l.id === lead.id)}
                onCheck={(id, checked) => handleLeadCheck(lead, checked)}
                onClick={() =>
                  setSelectedLead(selectedLead?.id === lead.id ? null : lead)
                }
              />

              {/* INLINE DETAILS */}
              {selectedLead?.id === lead.id && (
                <Card
                  style={{
                    background: "#fafafa",
                    marginTop: 8,
                    border: "1px solid #DBEAFF",
                  }}
                >
                  <Text strong>Lead Details</Text>
                  <Divider style={{ margin: "8px 0" }} />

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1px 1fr",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ padding: 6 }}>
                      <strong>Name</strong>
                      <div>{lead.name}</div>
                    </div>

                    <div
                      style={{
                        width: 1,
                        height: "100%",
                        background: "#DBEAFF",
                      }}
                    />

                    <div style={{ padding: 6 }}>
                      <strong>Contact No.</strong>
                      <div>{lead.contact}</div>
                    </div>
                  </div>

                  <Divider style={{ margin: "6px 0" }} />

                  {/* GRID ROW 2 */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1px 1fr",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ padding: 6 }}>
                      <strong>Client Location</strong>
                      <div>{lead.place}</div>
                    </div>

                    <div
                      style={{
                        width: 1,
                        height: "100%",
                        background: "#DBEAFF",
                      }}
                    />

                    <div style={{ padding: 6 }}>
                      <strong>Sq.ft</strong>
                      <div>{lead.sqft}</div>
                    </div>
                  </div>

                  <Divider style={{ margin: "6px 0" }} />

                  {/* GRID ROW 3 */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1px 1fr",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ padding: 6 }}>
                      <strong>Budget</strong>
                      <div>₹ {formatAmountIndian(lead.price)}</div>
                    </div>

                    <div
                      style={{
                        width: 1,
                        height: "100%",
                        background: "#DBEAFF",
                      }}
                    />

                    <div style={{ padding: 6 }}>
                      <strong>Preferred location</strong>
                      <p style={{ margin: 0 }}>
                        {[
                          lead?.state,
                          lead?.district,
                          lead?.area,
                          lead?.pincode,
                        ]
                          .filter(Boolean)
                          .join(" - ")}
                      </p>
                    </div>
                  </div>

                  <Divider style={{ margin: "6px 0" }} />

                  {/* GRID ROW 4 */}
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1px 1fr",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ padding: 6 }}>
                      <strong>Site Visit</strong>
                      <div>{lead.siteVisit}</div>
                    </div>

                    <div
                      style={{
                        width: 1,
                        height: "100%",
                        background: "#DBEAFF",
                      }}
                    />

                    <div style={{ padding: 6 }}>
                      <strong>Looking For</strong>
                      <div>{lead.lookingFor}</div>
                    </div>
                  </div>

                  {/* DYNAMIC CART BUTTON */}
                  {(() => {
                    const isChecked = cartLeads.some((l) => l.id === lead.id);

                    return (
                      <Button
                        size="middle"
                        onClick={(e) => {
                          e.stopPropagation();
                          if (isChecked) {
                            removeLeadFromCart(lead.id);
                          } else {
                            addLeadToCart(lead);
                          }
                        }}
                        onMouseEnter={() => setIsHoveredDetail(true)}
                        onMouseLeave={() => setIsHoveredDetail(false)}
                        icon={
                          isChecked ? (
                            isHoveredDetail ? (
                              <DeleteOutlined style={{ fontSize: 13 }} />
                            ) : (
                              <CheckOutlined style={{ fontSize: 13 }} />
                            )
                          ) : (
                            <ShoppingCartOutlined style={{ fontSize: 14 }} />
                          )
                        }
                        style={{
                          width: "100%",
                          marginTop: 16,
                          fontWeight: 600,
                          fontSize: 12,
                          borderRadius: 6,
                          height: "36px",
                          textTransform: "uppercase",
                          transition: "all 0.2s ease",
                          backgroundColor: isChecked
                            ? isHoveredDetail
                              ? "#ff4d4f"
                              : "#1677ff"
                            : isHoveredDetail
                            ? "#1677ff"
                            : "#ffffff",
                          color:
                            isChecked || isHoveredDetail
                              ? "#ffffff"
                              : "#1677ff",
                          borderColor: isChecked
                            ? isHoveredDetail
                              ? "#ff4d4f"
                              : "#1677ff"
                            : "#1677ff",
                          boxShadow:
                            isChecked || isHoveredDetail
                              ? "0 2px 6px rgba(22, 119, 255, 0.3)"
                              : "0 2px 4px rgba(0,0,0,0.05)",
                        }}
                      >
                        {isChecked
                          ? isHoveredDetail
                            ? "Remove"
                            : "Added"
                          : "Add"}
                      </Button>
                    );
                  })()}
                </Card>
              )}
            </div>
          ))
        )}
      </div>

      {isAllTab ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: 16,
          }}
        >
          <Pagination
            simple
            showSizeChanger={false}
            current={pagination.page}
            total={pagination.total || 10}
            pageSize={pagination.limit}
            onChange={(page) => fetchAllLeads(page, lastSearchParams)}
            style={{ marginTop: 8, textAlign: "center" }}
          />
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: 16,
          }}
        >
          <Pagination
            simple
            current={categoryPagination.page}
            total={categoryPagination.total || 10}
            pageSize={CATEGORY_PAGE_SIZE}
            showSizeChanger={false}
            onChange={categoryPagination.setPage}
          />
        </div>
      )}

      {/* CHART */}
      <Title level={5} style={{ marginTop: 16 }}>
        Lead Statistics
      </Title>

      <Card>
        <StatisticsChart />
      </Card>

      {/* CART BAR */}
      {cartLeads.length > 0 && (
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            background: "#fff",
            borderTop: "1px solid #ddd",
            padding: 12,
            display: "flex",
            justifyContent: "space-between",
            zIndex: 1000,
          }}
        >
          <div>
            <strong>{cartLeads.length}</strong>{" "}
            {cartLeads.length === 1 ? "lead" : "leads"} selected
            <div style={{ fontSize: 12, color: "#666" }}>
              * Amount may change in real time
            </div>
          </div>
          <Button type="primary" onClick={() => navigate("/my-cart")}>
            Buy Now
          </Button>
        </div>
      )}
    </div>
  );
}